const MuiCardHeader = {
	root: {
		padding: "16px 24px",
	},
};
export default MuiCardHeader;
